import React from 'react';

interface RightPointingArrowProps {
  size?: number; // Size of the entire component (circle + arrow)
  arrowColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
}

export const RightPointingArrow = ({ 
  size = 40, 
  arrowColor = '#6E7191',
  backgroundColor = '#F2F4F7',
  strokeWidth = 2 
}: RightPointingArrowProps) => {
  // Arrow SVG should be proportional to the container size
  const arrowSize = size * 0.5; // Arrow is 50% of container size
  
  return (
    <div 
      style={{ 
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      <svg width={arrowSize} height={arrowSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M1.5 12H22.5M22.5 12L12 1.5M22.5 12L12 22.5" 
          stroke={arrowColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
